import type { CurrentUser } from "@lucky-try/contracts";
import type { Permission } from "@lucky-try/shared";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { api, ApiRequestError } from "./api";

export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: async (): Promise<CurrentUser | null> => {
    try {
      return await api<CurrentUser>("/me");
    } catch (error) {
      if (error instanceof ApiRequestError && error.status === 401) return null;
      throw error;
    }
  },
  staleTime: 60_000,
});

export function useMe() {
  return useQuery(meQuery);
}

export function can(user: CurrentUser | null | undefined, permission: Permission): boolean {
  return Boolean(user?.permissions.includes(permission));
}

export function useCan(permission: Permission): boolean {
  const { data } = useMe();
  return can(data, permission);
}
